import makeFetch from "../../utils/http";

export type AppointmentDraft = {
    clientEmail: string;
    vetUserId: number;
    vetProfileId: number;
    animalType: string;
    pickedTimeSlot: string;
    state: string;
};

export function api_createAppointmentDraft(body: AppointmentDraft) {
    return makeFetch(
        "appointmentDrafts",
        "POST",
        {},
        JSON.stringify(body),
    );
}

export function api_getAppointmentDraft(): Promise<AppointmentDraft | null> {
    return makeFetch(
        "appointmentDrafts",
        "GET",
    ).catch(() => null);
}
